import { useMutation, useQuery } from '@apollo/client'

import {
  UpdateUserDeliveryInfo,
  UpdateUserDeliveryInfoMutation,
  UpdateUserDeliveryInfoMutationVariables,
  UserDeliveryInfo,
  UserDeliveryInfoQuery,
} from '@/clients/utoniq-core/schema'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { getUserInfoRegisterRedirect } from '@/core/native/storage'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { router, routerPages } = useRouter()
  const { data } = useQuery<UserDeliveryInfoQuery>(UserDeliveryInfo)
  const [updateUserDeliveryInfo] = useMutation<
    UpdateUserDeliveryInfoMutation,
    UpdateUserDeliveryInfoMutationVariables
  >(UpdateUserDeliveryInfo)

  return {
    state: {
      user: data?.user ?? null,
    },
    actions: {
      onSubmit: async values => {
        await updateUserDeliveryInfo({
          variables: {
            updateUserDeliveryInfoInputs: {
              fullName: data?.user?.fullName ?? '',
              phoneNumber: data?.user?.phoneNumber ?? '',
              address: {
                postalCode: values.postalCode,
                prefecture: values.prefecture,
                city: values.city,
                line1: values.line1,
                line2: values.line2,
              },
            },
          },
          update(cache, { data }) {
            const userDeliveryInfoResponse = data?.updateUserDeliveryInfo
            const existingUser = cache.readQuery<UserDeliveryInfoQuery>({
              query: UserDeliveryInfo,
            })
            if (existingUser && userDeliveryInfoResponse) {
              cache.writeQuery({
                query: UserDeliveryInfo,
                data: {
                  user: {
                    ...existingUser.user,
                    ...userDeliveryInfoResponse,
                  },
                },
              })
            }
          },
        })

        const userInfoRegisterRedirect = await getUserInfoRegisterRedirect()
        const redirectPath = userInfoRegisterRedirect.direction

        if (!redirectPath) {
          router.goBack(routerPages.AccountSetting)
          return
        }
        router.push(redirectPath)
      },
    },
  }
})
